import { render, staticRenderFns } from "./teamRow.vue?vue&type=template&id=af304e2c"
import script from "./teamRow.vue?vue&type=script&lang=js"
export * from "./teamRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports